/* eslint-disable no-unused-vars */
import Swiper from 'swiper/swiper-bundle';

function imageSlider() {
    const carousels = document.getElementsByClassName('imageCarousel__sliderContainer');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('imageCarousel__slider')[0];
        slider.setAttribute('id', `imageCarousel__slider-${i}`);
        const scrollbar = carousel.getElementsByClassName('imageCarousel__sliderScrollbar')[0];
        scrollbar.classList.add(`imageCarousel__sliderScrollbar-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('imageCarousel__sliderControls')[0];
        pagination.classList.add(`imageCarousel__sliderControls-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('imageCarousel__sliderControl-next')[0];
        nextButton.classList.add(`imageCarousel__sliderControl-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('imageCarousel__sliderControl-prev')[0];
        prevButton.classList.add(`imageCarousel__sliderControl-prev-${i}`);

        const imageCarouselSwiper = new Swiper(`#imageCarousel__slider-${i}`, {
            // Optional parameters
            slidesPerView: 'auto',
            loop: false,
            // autoHeight: true,
            grabCursor: true,
            effect: 'slide',
            watchOverflow: true,
            spaceBetween: 30,
            slidesOffsetBefore: 36,
            slidesOffsetAfter: 36,
            freeMode: {
                enabled: true,
                sticky: true,
            },

            // Scrollbar
            scrollbar: {
                el: `.imageCarousel__sliderScrollbar-${i}`,
                // hide: true,
                draggable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: `.imageCarousel__sliderControl-next-${i}`,
                prevEl: `.imageCarousel__sliderControl-prev-${i}`,
            },
        });
    }

}

const testimonialsSlider = () => {
    const carousels = document.getElementsByClassName('testimonials__main');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('testimonials__slider')[0];
        slider.setAttribute('id', `testimonials__slider-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('testimonials__sliderControls')[0];
        pagination.classList.add(`testimonials__sliderControls-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('testimonials__sliderControl-next')[0];
        nextButton.classList.add(`testimonials__sliderControl-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('testimonials__sliderControl-prev')[0];
        prevButton.classList.add(`testimonials__sliderControl-prev-${i}`);

        const totalSlides = carousel.querySelectorAll(".swiper-slide").length;

        const testimonialsCarouselSwiper = new Swiper(`#testimonials__slider-${i}`, {
            // Optional parameters
            slidesPerView: 1,
            loop: totalSlides > 1,
            autoHeight: true,
            grabCursor: true,
            effect: 'fade',
            watchOverflow: true,
            fadeEffect: {
                crossFade: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: `.testimonials__sliderControl-next-${i}`,
                prevEl: `.testimonials__sliderControl-prev-${i}`,
            },
        });
    }

};

function postCardSlider() {
    const carousels = document.getElementsByClassName('postCarousel__sliderContainer');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('postCarousel__slider')[0];
        slider.setAttribute('id', `postCarousel__slider-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('postCarousel__sliderControls')[0];
        pagination.classList.add(`postCarousel__sliderControls-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('postCarousel__sliderControl-next')[0];
        nextButton.classList.add(`postCarousel__sliderControl-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('postCarousel__sliderControl-prev')[0];
        prevButton.classList.add(`postCarousel__sliderControl-prev-${i}`);

        const postsCardCarouselSwiper = new Swiper(`#postCarousel__slider-${i}`, {
            // Optional parameters
            slidesPerView: 2.2,
            loop: false,
            grabCursor: true,
            effect: 'slide',
            watchOverflow: true,
            spaceBetween: 42,
            slidesOffsetBefore: 36,
            slidesOffsetAfter: 36,
            // Navigation arrows
            navigation: {
                nextEl: `.postCarousel__sliderControl-next-${i}`,
                prevEl: `.postCarousel__sliderControl-prev-${i}`,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 30,
                },
                // when window width is >= 1040px
                1040: {
                    slidesPerView: 2.2,
                    spaceBetween: 42,
                }
            }
        });
    }
}

function locationCardSlider() {
    const carousels = document.getElementsByClassName('locationCardCarousel__sliderContainer');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('locationCardCarousel__slider')[0];
        slider.setAttribute('id', `locationCardCarousel__slider-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('locationCardCarousel__sliderControls')[0];
        pagination.classList.add(`locationCardCarousel__sliderControls-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('locationCardCarousel__sliderControl-next')[0];
        nextButton.classList.add(`locationCardCarousel__sliderControl-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('locationCardCarousel__sliderControl-prev')[0];
        prevButton.classList.add(`locationCardCarousel__sliderControl-prev-${i}`);

        const totalSlides = carousel.querySelectorAll(".swiper-slide").length;

        const locationCardCarouselSwiper = new Swiper(`#locationCardCarousel__slider-${i}`, {
            // Optional parameters
            // set slidesPerView to a whole number if slides are less than 4

            slidesPerView: totalSlides < 4 ? totalSlides : 3.3,
            loop: false,
            grabCursor: true,
            effect: 'slide',
            watchOverflow: true,
            spaceBetween: 44,
            slidesOffsetBefore: totalSlides < 4 ? 0 : 36,
            slidesOffsetAfter: totalSlides < 4 ? 0 : 36,
            // Navigation arrows
            navigation: {
                nextEl: `.locationCardCarousel__sliderControl-next-${i}`,
                prevEl: `.locationCardCarousel__sliderControl-prev-${i}`,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: totalSlides < 2 ? totalSlides : 1.2,
                    slidesOffsetBefore: totalSlides < 2 ? 0 : 36,
                    slidesOffsetAfter: totalSlides < 2 ? 0 : 36,
                    spaceBetween: 15,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: totalSlides < 3 ? totalSlides : 2.3,
                    slidesOffsetBefore: totalSlides < 3 ? 0 : 36,
                    slidesOffsetAfter: totalSlides < 3 ? 0 : 36,
                    spaceBetween: 30,
                },
                // when window width is >= 1040px
                1024: {
                    slidesPerView: totalSlides < 4 ? totalSlides : 3.3,
                    slidesOffsetBefore: totalSlides < 4 ? 0 : 36,
                    slidesOffsetAfter: totalSlides < 4 ? 0 : 36,
                    spaceBetween: 44,
                }
            },
        });
    }
}

function featuredBlogSlider() {
    const carousels = document.getElementsByClassName('blogOverview__featuredSliderContainer');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('postCarousel__slider')[0];
        slider.setAttribute('id', `featuredPostCarousel__slider-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('postCarousel__sliderControls')[0];
        pagination.classList.add(`featuredPostCarousel__sliderControls-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('postCarousel__sliderControl-next')[0];
        nextButton.classList.add(`featuredPostCarousel__sliderControls-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('postCarousel__sliderControl-prev')[0];
        prevButton.classList.add(`featuredPostCarousel__sliderControls-prev-${i}`);

        const postsCardCarouselSwiper = new Swiper(`#featuredPostCarousel__slider-${i}`, {
            // Optional parameters
            slidesPerView: 1.8,
            slidesPerGroup: 1,
            loop: true,
            spaceBetween: 24,
            grabCursor: true,
            watchOverflow: true,
            centeredSlides: true,
            centerInsufficientSlides: true,
            roundLengths: true,
            speed: 1000,
            autoHeight: false,
            slideToClickedSlide: true,
            // Navigation arrows
            navigation: {
                nextEl: `.featuredPostCarousel__sliderControls-next-${i}`,
                prevEl: `.featuredPostCarousel__sliderControls-prev-${i}`,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 12,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 1.8,
                    spaceBetween: 24,
                },
            }
        });

    }
}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    imageSlider();
    testimonialsSlider();
    postCardSlider();
    locationCardSlider();
    featuredBlogSlider();

};

export default init;
